import script from "./PreSportCouponsCompetitionsTime.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportCouponsCompetitionsTime.vue?vue&type=script&setup=true&lang=js"

import "./PreSportCouponsCompetitionsTime.vue?vue&type=style&index=0&id=ab820700&scoped=true&lang=css"
import "./PreSportCouponsCompetitionsTime.vue?vue&type=style&index=1&id=ab820700&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab820700"]])

export default __exports__